import React from "react";
import BannerLanding from "../../components/wtf-banners/BannerLanding";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import "../../styles/wtf-banner/wtf-banner.css"


const WtfBanner = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Banners">
      <BannerLanding userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default WtfBanner;
